<template>
  <v-text-field
    ref="textfield"
    v-bind="$attrs"
    :hide-details="showErrorsWithTooltip ? true : hideDetails"
    :data-cy="dataCy ? dataCy : false"
    class="c-text-field"
    autocomplete="disable"
    v-on="$listeners"
    @update:error="setErrorsBucket">
    <template #message="{ message }">
      {{ parseError(message) }}
    </template>

    <template #append>
      <v-tooltip v-if="showErrorsWithTooltip && errorsList" color="red" bottom>
        <template #activator="{ on }">
          <v-icon color="red" class="v-icon--circle error-icon-tooltip" v-on="on">$warning</v-icon>
        </template>
        {{ errorsList }}
      </v-tooltip>
      <slot v-else name="append"></slot>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'CTextField',
  inheritAttrs: false,
  props: {
    errorMessage: {
      type: String,
      default: '',
    },
    showErrorsWithTooltip: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: [Boolean, String],
      default: false,
    },
    dataCy: {
      type: [String, Boolean],
      default: '',
    },
  },
  data() {
    return {
      errorBucket: [],
    };
  },
  computed: {
    errorsList() {
      if (this.errorMessage) {
        return this.errorMessage;
      }

      return this.errorBucket.join(',');
    },
  },
  mounted() {
    this.setErrorsBucket();
  },
  methods: {
    parseError(validationErr) {
      if (this.errorMessage) {
        return this.errorMessage;
      }

      try {
        const error = JSON.parse(validationErr);
        return this.$t(error.text, error.params);
      } catch (e) {
        return this.$t(validationErr);
      }
    },
    setErrorsBucket() {
      this.errorBucket = this.$refs.textfield.errorBucket.map(el => this.parseError(el));
    },
  },
};
</script>

<style lang="scss">
.c-text-field {
  .error-icon-tooltip {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
  }
}

.v-application--is-rtl {
  .v-input__control {
    .v-input.v-text-field.v-text-field--enclosed.v-text-field--outlined.v-text-field--prefix .v-label {
      left: none !important;
      right: 0 !important;
    }
    .v-text-field__prefix {
      order: 1;
    }
  }
}

</style>
